export default __webpack_public_path__ + "static/yoga-11-b938709f8af258f3e2a1fafa03934f83.png";